import PropTypes from 'prop-types'
import { Svg } from 'components/icons/index'

function Favorite({ stroke, fill, color }) {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill || color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.517 17.0209L12.0003 16.709L11.4835 17.0209L6.68166 19.9191L7.95611 14.4572L8.09327 13.8694L7.63703 13.4742L3.39354 9.79812L8.97877 9.32442L9.57965 9.27346L9.81498 8.71825L12.0003 3.56248L14.1856 8.71825L14.4209 9.27346L15.0218 9.32442L20.607 9.79812L16.3635 13.4742L15.9073 13.8694L16.0444 14.4572L17.3189 19.9191L12.517 17.0209Z"
        stroke={stroke || color}
        strokeWidth="2"
      />
    </Svg>
  )
}

export default Favorite
